export const testContext = {
  channel: "Testing",
  type: "general",
  mappings: [
    {
      key: "specificUrlAllFalse",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/specificURL/testing/Values",
      categoryId: "TESTING_CATEGORY",
      page_key: "Login",
      reportData: {},
    },
    {
      key: "specificUrLDefault",
      useDefault: true,
      isGeneric: false,
      useReportingData: false,
      url: "/specificURL/testing/defaultValues",
      categoryId: "TESTING_CATEGORY",
      page_key: "DEFAULT",
      reportData: {},
    },
    {
      key: "genericUrLSpecificKey",
      useDefault: false,
      isGeneric: true,
      useReportingData: false,
      url: "/genericURL/testing/SpecificPageValue",
      categoryId: "TESTING_CATEGORY",
      page_key: "EXACT_KEY_VALUE",
      reportData: {},
    },
    {
      key: "genericUrLDefaultKey",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/genericURL/testing/DEFAULTPageValue",
      categoryId: "TESTING_CATEGORY",
      page_key: "NOT_EXACT_KEY_VALUE",
      reportData: {},
    },
    {
      key: "specificUrlWithReportingData",
      useDefault: false,
      isGeneric: false,
      useReportingData: true,
      url: "/specificURL/testing/ReportingValues/notEqualNull",
      categoryId: "NOT_TEST_CATEGORY",
      page_key: "NOT_EXACT_KEY_VALUE",
      reportData: {
        fields: [
          {
            key: "currentPage",
            type: "string",
            conditional: {
              comparison: "NOT_EQUALS",
              value: null,
              passActions: [
                { task: "pageKey", type: "value", valueKey: "PASSED_PAGEKEY" },
                { task: "categoryId", type: "value", valueKey: "PASSED_CATEGORY" },
              ],
              failActions: [
                { task: "pageKey", type: "value", valueKey: "FAILED_PAGEKEY" },
                { task: "categoryId", type: "value", valueKey: "FAILED_CATEGORY" },
              ],
            },
          },
        ],
      },
    },
    {
      key: "specificUrlDefaultWithReportingData",
      useDefault: true,
      isGeneric: false,
      useReportingData: true,
      url: "/specificURL/testing/ReportingValues/defaultStringPage",
      categoryId: "NOT_TEST_CATEGORY",
      page_key: "NOT_EXACT_KEY_VALUE",
      reportData: {
        fields: [
          {
            key: "currentPage",
            type: "string",
            conditional: {
              comparison: "NOT_EQUALS",
              value: null,
              passActions: [
                { task: "categoryId", type: "value", valueKey: "PASSED_CATEGORY" },
              ],
              failActions: [
                { task: "pageKey", type: "value", valueKey: "FAILED_PAGEKEY" },
                { task: "categoryId", type: "value", valueKey: "FAILED_CATEGORY" },
              ],
            },
          },
        ],
      },
    },
    {
      key: "specificUrlDefaultWithReportingData",
      useDefault: true,
      isGeneric: false,
      useReportingData: true,
      url: "/specificURL/testing/ReportingValues/defaultBooleanPage",
      categoryId: "NOT_TEST_CATEGORY",
      page_key: "NOT_EXACT_KEY_VALUE",
      reportData: {
        fields: [
          {
            key: "currentPage",
            type: "boolean",
            conditional: {
              comparison: "EQUALS",
              value: true,
              passActions: [
                { task: "categoryId", type: "value", valueKey: "PASSED_CATEGORY" },
              ],
              failActions: [
                { task: "pageKey", type: "value", valueKey: "FAILED_PAGEKEY" },
                { task: "categoryId", type: "value", valueKey: "FAILED_CATEGORY" },
              ],
            },
          },
        ],
      },
    },
    {
      key: "specificUrlDefaultWithReportingDataArray",
      useDefault: true,
      isGeneric: false,
      useReportingData: true,
      url: "/specificURL/testing/ReportingValues/defaultArrayPage",
      categoryId: "NOT_TEST_CATEGORY",
      page_key: "NOT_EXACT_KEY_VALUE",
      reportData: {
            fields: [
             {
                key: "products",
                type: "array",
                indexToProcess: "0",
                fields: [
                  {
                    key: "businessArea",
                    type: "string",
                    conditional: {
                      comparison: "EQUALS",
                      value: "business",
                      passActions:[
                        {
                          task: "next",
                        },
                      ],
                      failActions:[
                        {
                          task: "exit",
                        },
                      ],
                    },
                  },
                  {
                    key: "subProductCode",
                    type: "string",
                    conditional: {
                      comparison: "EQUALS",
                      value: "7S",
                      passActions:[
                        { task: "pageKey", type: "variable", valueKey: "currentPage" },
                        { task: "categoryId", type: "value", valueKey: "PASSED_CATEGORY" },
                      ],
                      failActions:[
                        {
                          task: "exit",
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
    },
    // {
    //   key: "genericUrlWithReportingData",
    //   useDefault: false,
    //   isGeneric: true,
    //   useReportingData: true,
    //   url: "/genericURL/testing/ReportingDataValue",
    //   categoryId: "TESTING_CATEGORY",
    //   page_key: "NOT_EXACT_KEY_VALUE",
    //   reportData: {
    //   },
    // },
    // {
    //   key: "apply",
    //   useDefault: true,
    //   isGeneric: true,
    //   useReportingData: true,
    //   url: "/usl/business/deposit/application/dda/7s",
    //   categoryId: "TESTING_CATEGORY",
    //   page_key: "DEFAULT",
    //   reportData: {
    //     fields: [
    //       {
    //         key: "currentPage",
    //         type: "string",
    //         conditional: {
    //           comparison: "NOT_EQUALS",
    //           value: null,
    //           passActions:[
    //               {
    //                 task: "next",
    //               },
    //             ],
    //           failActions:[
    //               {
    //                 task: "exit",
    //               },
    //             ],

    //         }
    //       },
    //       {
    //         key: "applyPlatform",
    //         type: "string",
    //         conditional: {
    //         comparison: "NOT_EQUALS",
    //         value: null,
    //         passActions:[
    //           {
    //             task: "next",
    //           },
    //         ],
    //       failActions:[
    //           {
    //             task: "exit",
    //           },
    //         ],

    //         },
    //      },
    //       {
    //         key: "products",
    //         type: "array",
    //         indexToProcess: "0",
    //         fields: [
    //           {
    //             key: "businessArea",
    //             type: "string",
    //             conditional: {
    //               comparison: "EQUALS",
    //               value: "business",
    //               passActions:[
    //                 {
    //                   task: "next",
    //                 },
    //               ],
    //               failActions:[
    //                 {
    //                   task: "exit",
    //                 },
    //               ],
    //             },
    //           },
    //           {
    //             key: "productCode",
    //             type: "string",
    //             conditional: {
    //               comparison: "EQUALS",
    //               value: "DDA",
    //               passActions:[
    //                 {
    //                   task: "next",
    //                 },
    //               ],
    //               failActions:[
    //                 {
    //                   task: "exit",
    //                 },
    //               ],
    //             },
    //           },
    //           {
    //             key: "subProductCode",
    //             type: "string",
    //             conditional: {
    //               comparison: "EQUALS",
    //               value: "7S",
    //               passActions:[
    //                 { task: "pageKey", type: "variable", valueKey: "currentPage" },
    //                 { task: "categoryId", type: "value", valueKey: "APPLY_BB_PSP_USBANK" },
    //               ],
    //               failActions:[
    //                 {
    //                   task: "exit",
    //                 },
    //               ],
    //             },
    //           },
    //         ],
    //       },
    //     ],
    //   },
    // },
    // {
    //   key: "apply",
    //   useDefault: false,
    //   isGeneric: true,
    //   useReportingData: true,
    //   url: "/business/deposit/application/dda/",
    //   categoryId: "APPLY_BB_PSP_USBANK",
    //   page_key: "DEFAULT",
    //   reportData: {
    //     fields: [
    //       {
    //         key: "currentPage",
    //         type: "string",
    //         conditional: {
    //           comparison: "NOT_EQUALS",
    //           value: null,
    //           passActions:[
    //             {
    //               task: "next",
    //             },
    //           ],
    //           failActions:[
    //             { task: "pageKey", type: "value", valueKey: null },
    //           ],
    //         },
    //       },
    //       {
    //         key: "F99_isCustomerContactReceived",
    //         type: "boolean",
    //         conditional: {
    //           comparison: "EQUALS",
    //           value: true,
    //           passActions:[
    //             { task: "pageKey", type: "value", valueKey: "F99_DECLINE" },
    //             { task: "categoryId", type: "value", valueKey: "APPLY_BB_PSP_USBANK" },
    //             { task: "exit" },
    //           ],
    //           failActions:[
    //             {
    //               task: "next",
    //             },
    //           ],

    //         },
    //       },
    //       {
    //         key: "F95_isSoftDecline",
    //         type: "boolean",
    //         conditional: {
    //           comparison: "EQUALS",
    //           value: true,
    //           passActions:[
    //             { task: "pageKey", type: "variable", valueKey: "F95_DECLINE" },
    //             { task: "categoryId", type: "value", valueKey: "APPLY_BB_PSP_USBANK" },
    //           ],
    //           failActions:[
    //             {
    //               task: "next",
    //             },
    //           ],

    //         },
    //       }
    //     ],
    //   },
    // }
  ],
};
